import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card'

interface ObservationsProps {
  leadershipPerceptions: string[]
  variabilityNotes: string[]
}

export function ObservationsSection({ leadershipPerceptions, variabilityNotes }: ObservationsProps) {
  if (!leadershipPerceptions?.length && !variabilityNotes?.length) return null

  return (
    <div className="grid md:grid-cols-2 gap-6">
      {leadershipPerceptions?.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle>Leadership Perceptions</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-6 space-y-2">
              {leadershipPerceptions.map((observation, index) => (
                <li key={index} className="text-sm text-muted-foreground [&>p]:inline">
                  {observation}
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      )}

      {variabilityNotes?.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle>Variability Analysis</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-6 space-y-2">
              {variabilityNotes.map((note, index) => (
                <li key={index} className="text-sm text-muted-foreground [&>p]:inline">
                  {note}
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      )}
    </div>
  )
}